import React, { useEffect, useState, useRef } from 'react';
import qs from 'qs';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import loadingImg from 'images/icon/yellow_loading-40x40.gif';
import defaultBannerImg from 'images/default_campaign_banner_163x163.png';
import server from 'server/serverController2';
import constants from 'utils/constants'
import { formatDate } from 'utils/utils.js';
import { differenceInDays } from 'date-fns';

import CampaignMainListTop from 'components/containers/campaign/list/CampaignMainListTop'

export default function CampaignMainList({scrollRef,type}) {
  const userInfo = useSelector((state) => {
    return state.userInfo;
  });

  const itemPerPage = 20;
  const [currTab, setCurrTab] = useState('joinable');
  const [campaignList, setCampaignList] = useState([]);
  const [offset, setOffset] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isEnd, setIsEnd] = useState(false);
  const listDomRef = useRef(null);

  const campaignListRef = useRef(campaignList); 
  const offsetRef = useRef(offset);
  const isLoadingRef = useRef(isLoading);
  const isEndRef = useRef(isEnd);
  const currTabRef = useRef(currTab);

  const updateCampaignList = (data)=>{
    campaignListRef.current = data;
    setCampaignList(data);
  } 
  const updateOffset = (data)=>{
    offsetRef.current = data;
    setOffset(data);
  }
  const updateIsLoading = (data)=>{
    isLoadingRef.current = data;
    setIsLoading(data);
  }
  const updateIsEnd = (data)=>{
    isEndRef.current = data;
    setIsEnd(data);
  }

  const updateCurrTab = (data)=>{
    currTabRef.current = data;
    setCurrTab(data);
  }

  const loadCampaignList = async (e)=> {
    try {
      updateIsLoading(true);

      const queryObj = {
        order_by:'pin_no', 
        status:'published', 
        limit:itemPerPage, 
        offset : offsetRef.current ? offsetRef.current : 0
      }

      if(type === 'company') {
        queryObj['type'] = 'company';
      } else {
        queryObj['types'] = ['normal','shinhan']; 
      }

      if(currTabRef.current === 'joinable') {
        queryObj['joinable'] = true;
      } else if (currTabRef.current === 'progress') {
        queryObj['not_null'] = ['start_date'];
        queryObj['start_date_lt'] = formatDate();
        queryObj['end_date_ge'] = formatDate();
      } else if (currTabRef.current === 'complete') {
        queryObj['end_date_lt'] = formatDate();
      }

      const queryString = qs.stringify(queryObj);

      const urlEndPoint = type === 'company' ? `users/${userInfo['id']}/companies/campaigns?${queryString}` : `campaigns?${queryString}`;

      const response = await server.getRequestData(urlEndPoint);

      if(response.success !== 1) {
        const errData = response.error.res_data;
        throw errData;
      }

      const jsonData = response.data;
      const  receivedGroupList = jsonData['campaigns'];
      
      if(receivedGroupList?.length && receivedGroupList.length > 0 ) {
        const nextOffset = (offsetRef.current)?offsetRef.current+itemPerPage:itemPerPage;
        updateOffset(nextOffset) 
        updateCampaignList([...campaignListRef.current, ...receivedGroupList]);
      } else {
        updateIsEnd(true);
      }
      
      if(receivedGroupList.length < itemPerPage)
      {
        updateIsEnd(true);
      }
      updateIsLoading(false);

    } catch(error) {
      console.log(error);
    }
  }

  useEffect(()=>{ 
    updateCampaignList([]);
    updateOffset(null)
    updateIsLoading(false)
    updateIsEnd(false);

    loadCampaignList(); 
  },[currTab])
  // useEffect(() => {
  //   loadCampaignList();
  // }, []);
  useEffect(()=>{
    
    let groupScrollRef = (scrollRef)? scrollRef: listDomRef;
    if(groupScrollRef?.current)
    {

      let infiniteScrollEvt = (e)=>{
        if(!isLoadingRef.current && !isEndRef.current && offsetRef.current) 
        {
          const bottom = e.target.scrollHeight - e.target.scrollTop - 100 <= e.target.clientHeight;
          if (bottom) {
            loadCampaignList();
          }
        }
      };

      groupScrollRef.current.addEventListener("scroll", infiniteScrollEvt)
      // loadCampaignList();
      return ()=>{
        if(groupScrollRef?.current?.removeEventListener)
        {
          groupScrollRef.current.removeEventListener("scroll",infiniteScrollEvt)
        }
      };
    }
  },[])

  return (
    <div ref={listDomRef}>
      <div style={{marginBottom: 'calc(100vw * (25 / 375))'}}>
        <CampaignMainListTop initTab={currTab} onSelect={(newTab)=>{updateCurrTab(newTab)}}/>
      </div>
      <ListWrapper>
      {(isEnd && campaignList.length === 0)?(<ChallengeEmptyMsg><ChallengeEmptyMsgTxt>아직 등록된 챌린지가 없어요 </ChallengeEmptyMsgTxt></ChallengeEmptyMsg>):(null)}
      {
        campaignList.map((value, index)=>{
          let bannerImg = (value['banner_img'])?`${constants['imagePath']}/campaign_banner_img/${value['banner_img']}`:defaultBannerImg;
          let remainedDay = differenceInDays(new Date(value['start_date']), new Date(formatDate()));
          let isFinished = (differenceInDays(new Date(value['end_date']), new Date(formatDate())) < 0) ? true : false ;
          let statusTxt = '';
          if(isFinished)
          {
            statusTxt = '마감';
          }
          else if(value['start_date'] === null)
          {
            statusTxt = '상시모집';
          }
          else if(remainedDay < 0)
          {
            statusTxt = '진행중';
          }
          else if(remainedDay === 0)
          {
            statusTxt = '오늘마감!';
          } 
          else
          {
            statusTxt = `D-${remainedDay}`;
          }

          const capacityStatus = [];
          if(value?.max_capacity > 0)
          {
            if(value?.max_capacity === value?.current_capacity)
            {
              capacityStatus.push(<CapacityStatus key={`campaign-capacity-status-item-${value['no']}`}>선착순 마감</CapacityStatus>)
            }
            else
            {
              capacityStatus.push(<CapacityStatus key={`campaign-capacity-status-item-${value['no']}`}>선착순!</CapacityStatus>)
            }
          }
          
          return(
            <CampaignItem to={`campaign/${value['no']}`} key={`campaign-list-item-${value['no']}`}>
              <BannerImgWrapper>
{/*
                <CampaignGradation></CampaignGradation>*/}
                <StatusTxt>{statusTxt}</StatusTxt>
                <ImgWrapper>
                  <CampaignBannerImg src={bannerImg} />
                </ImgWrapper>
                {capacityStatus}
              </BannerImgWrapper>
              <CampaignInfo>
                <CampaignTitleTxt>{value.title}</CampaignTitleTxt>
              </CampaignInfo>
            </CampaignItem>
          )
        })
      }
      </ListWrapper>
      {
        (!isEnd)
        ?(
          <LoadingImgWrapper>
            <LoadingImg src={loadingImg}/>
          </LoadingImgWrapper>
        )
        :(null)
      }
    </div>
  );
}
const ListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`
const CampaignItem = styled(Link)`
  width : 47.5%;
  margin-bottom :  calc(100vw * (35 / 375));
`;
const BannerImgWrapper = styled.div`
  padding-top: 100%;
  position: relative;  
  margin-bottom :  calc(100vw * (9 / 375));
`;
const StatusTxt = styled.span`
font-family: Noto Sans;
  position:absolute;
  top: calc(100vw * (8 / 375));
  right: calc(100vw * (8 / 375));
  border: 0.5px solid #FFFFFF;
  border-radius: calc(100vw * (4 / 375));
  background: rgba(0, 0, 0, 0.5);
  padding: calc(100vw * (2 / 375)) calc(100vw * (7 / 375));
  z-index:100;
  color: #FFFFFF;
  font-weight: bold;
  font-size: calc(100vw * (10 / 375));
  line-height: calc(100vw * (16 / 375));
`;
const ImgWrapper = styled.div`
  position: absolute;
  top : 0;
  bottom: 0;
  left:0;
  right:0;
  margin:auto;
  border-radius: calc(100vw * (8 / 375));
  overflow: hidden;
`;
const CampaignBannerImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const CampaignGradation = styled.div`
height: 40%;
width : 100%;
position: absolute;
bottom : 0;
background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.30625) 59.37%, rgba(0, 0, 0, 0) 100%);
z-index: 1;
border-bottom-left-radius: calc(100vw * (8 / 375));
border-bottom-right-radius: calc(100vw * (8 / 375));
`

const CampaignInfo = styled.span`
`
const CampaignTitleTxt = styled.span`
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const LoadingImgWrapper = styled.div`
  text-align: center;
`;
const LoadingImg = styled.img`
  width :calc(100vw*(40/375));
  height:calc(100vw*(40/375));
`
const ChallengeEmptyMsg = styled.div`

`;
const ChallengeEmptyMsgTxt = styled.span`
  font-weight: 500;
  font-size: calc(100vw*(14/375));
  line-height: calc(100vw*(20/375));
  color: #989898;
`;

const CapacityStatus = styled.div` 
  font-style: normal;
  font-weight: bold;
  font-size: calc(100vw*(12/375)); 
  color: #4E4E4E;
  position: absolute;
  bottom : calc(100vw*(7/375));
  right : calc(100vw*(7/375));
  padding : calc(100vw*(6/375)) calc(100vw*(8/375));
  background: #FFCF19;
  border-radius: calc(100vw*(5/375));
  z-index: 2;
`